/**
 * Сельдевые — 2 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const СЕЛЬДЕВЫЕ = [
    // ── Иберия и Италия ──
    {
        id: 'agone',
        семейство: 'сельдевые',
        latin: 'Alosa agone',
        повадка: 'стайная_бель',
        minKg: 0.05,
        maxKg: 0.4,
        typicalKg: 0.15,
        typicalLengthM: 0.28,
        depthM: 10,
        depthBandM: 6,
        сложение: 'ленточное',
        пасть: 'тонкогубая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 6, опт: 15, макс: 24 },
        течение: 'стоячая',
        держится: ['открытая_вода', 'бровка', 'поверхность'],
        стая: 'большая_стая',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'мушка', вес: 1 },
            { чем: 'опарыш', вес: 0.8 },
            { чем: 'spoon', вес: 0.4 },
            { чем: 'мотыль', вес: 0.4 },
            { чем: 'spinner', вес: 0.2 },
        ],
    },
    // ── Балканы, Дунай и Междуречье ──
    // Карстовые реки Далмации, дунайский ход сельди и усачи Тигра с Евфратом.
    {
        id: 'danube_shad',
        семейство: 'сельдевые',
        latin: 'Alosa immaculata',
        повадка: 'угонщик',
        minKg: 0.15,
        maxKg: 0.8,
        typicalKg: 0.4,
        typicalLengthM: 0.33,
        depthM: 3,
        depthBandM: 2,
        сложение: 'ленточное',
        пасть: 'тонкогубая',
        редкость: 'редкая',
        когда: 'сумеречная',
        вода: { мин: 5, опт: 14, макс: 22 },
        течение: 'сильное',
        держится: ['открытая_вода', 'бровка', 'поверхность'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'wobbler', вес: 0.4 },
            { чем: 'jig', вес: 0.2 },
        ],
        краснокнижная: true,
    },
];
//# sourceMappingURL=clupeids.js.map